export const center_app_version = {"commit_sha": "51793231"}
